import { Reveal } from "./Reveal";
import { MANIFESTO } from "../../data/content";

export const Manifesto = () => (
  <section id="metodologia" data-testid="manifesto-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase font-mono tracking-[0.28em] text-emerald-600 dark:text-emerald-400 font-semibold mb-4">Nuestra metodología</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
          Formamos contadores que las empresas <span className="font-serif italic text-emerald-500">buscan</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.num} delay={i * 0.1} className={i % 2 === 1 ? "lg:mt-14" : ""}>
            <div data-testid={`manifesto-chapter-${m.num}`} className="group relative rounded-2xl border border-border bg-card p-7 h-full transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(16,185,129,0.12)] hover:border-emerald-500/40">
              <span className="font-mono text-5xl font-semibold text-outline text-emerald-500/70 group-hover:text-emerald-500 transition-colors">{m.num}</span>
              <h3 className="font-display text-xl font-semibold tracking-tight mt-5">{m.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mt-3">{m.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
